import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'cyan' | 'outlineCyan';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98] select-none';
  const variants = {
    primary: 'bg-[#7FFF00] text-black hover:bg-[#6FEF00] focus:ring-[#7FFF00] shadow-md shadow-[#7FFF00]/20 hover:shadow-xl hover:shadow-[#7FFF00]/30 hover:-translate-y-0.5 border border-transparent',
    cyan: 'bg-[#06B6D4] text-white hover:bg-[#0891b2] focus:ring-[#06B6D4] shadow-md shadow-[#06B6D4]/20 hover:shadow-xl hover:shadow-[#06B6D4]/30 hover:-translate-y-0.5 border border-transparent',
    secondary: 'bg-blue-500 text-white hover:bg-blue-600 focus:ring-blue-500 shadow-md shadow-blue-500/20 hover:shadow-xl hover:shadow-blue-500/30 hover:-translate-y-0.5 border border-transparent',
    outline: 'border-2 border-slate-200 bg-transparent text-slate-700 hover:border-[#7FFF00] hover:text-[#7FFF00] hover:bg-[#7FFF00]/5 focus:ring-[#7FFF00]',
    outlineCyan: 'border-2 border-slate-200 bg-transparent text-slate-700 hover:border-[#06B6D4] hover:text-[#06B6D4] hover:bg-[#06B6D4]/5 focus:ring-[#06B6D4]',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus:ring-slate-500'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm gap-2',
    md: 'h-11 px-6 text-base gap-2.5',
    lg: 'h-14 px-8 text-lg gap-3'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-383">
      {isLoading && <Loader2 className="h-5 w-5 animate-spin flex-shrink-0" data-id="element-384" />}
      {!isLoading && leftIcon && <span className="flex-shrink-0 transition-transform duration-200 group-hover:scale-110" data-id="element-385">
          {leftIcon}
        </span>}
      <span className="text-center truncate" data-id="element-386">{children}</span>
      {!isLoading && rightIcon && <span className="flex-shrink-0 transition-transform duration-200 group-hover:translate-x-0.5" data-id="element-387">
          {rightIcon}
        </span>}
    </button>;
}